import { type TeamMember, TeamMemberRole } from '@api'
import { Controller, useFormContext } from 'react-hook-form'

import { Checkbox } from '@/components/ui/checkbox'
import { FormSelect } from '@/components/ui/form/FormSelect.tsx'
import { FormField } from '@/components/ui/form/form-field'
import { RolesSelector } from '@/modules/creators/ui/RoleSelector'
import type { TeamMemberEditFormValues } from '@/modules/team/views/edit/team-edit-form'

interface Props {
  member: TeamMember
  className?: string
}

export const TeamGeneralInfoForm = ({ member, className }: Props) => {
  const { watch, setValue } = useFormContext<TeamMemberEditFormValues>()

  const role = watch('role')

  const handleRoleChange = (role: string) => {
    if (role === TeamMemberRole.LEADER || role === TeamMemberRole.ADMIN) {
      setValue('roleIds', [])
    }
  }
  const isSuperUser =
    role === TeamMemberRole.LEADER || role === TeamMemberRole.ADMIN

  return (
    <div className={className}>
      <div className="col-span-1 flex flex-col gap-4">
        <FormField
          name="name"
          label="Name"
          showErrors={false}
          className="w-full"
        />

        <FormField
          name="email"
          label="Email"
          showErrors={false}
          disabled
          className="w-full"
        />
      </div>
      <div className="flex flex-col gap-4">
        <FormSelect
          options={['Admin', 'Member']}
          name="role"
          label="User Type"
          className="w-full"
          disabled={member.role === TeamMemberRole.LEADER}
          onChange={handleRoleChange}
        />
        <Controller
          name="roleIds"
          render={({ field }) => {
            return (
              <RolesSelector
                selectedRoleIds={field.value}
                onChange={field.onChange}
                disabled={isSuperUser}
                label="Roles"
                name={field.name}
                className="col-span-1"
                disabledReason={
                  isSuperUser ? 'Admins have all permissions' : undefined
                }
                showSelectedRoles={!isSuperUser}
              />
            )
          }}
        />
      </div>
      <Controller
        name="nsfwAlwaysOn"
        render={({ field }) => (
          <label>
            <Checkbox
              checked={field.value}
              onCheckedChange={field.onChange}
            />
            <span className="ml-3 text-sm">NSFW Always On</span>
          </label>
        )}
      />
    </div>
  )
}
